"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("../models/globals");
class Assistance extends webix_jet_1.JetView {
    config() {
        return {
            view: "window",
            height: 800,
            width: 650,
            modal: true,
            position: "center",
            head: (0, globals_1._)("Demande d'assistance"),
            body: {
                view: "form", id: "assistance.data",
                elementsConfig: { maxWidth: 500, labelAlign: "right", labelWidth: 120,
                    on: { onChange: function (newValue) { globals_1.lv2.clean(newValue, this); } }
                },
                elements: [{
                        view: "text", name: "nom", label: (0, globals_1._)("Nom"),
                        width: "300", attributes: { maxlength: 40 },
                        editor: "text", disabled: true
                    }, {
                        view: "text", name: "prenom", label: (0, globals_1._)("Prénom"),
                        width: "250", attributes: { maxlength: 40 },
                        editor: "text", disabled: true
                    }, {
                        view: "text", name: "idUtilisateur", label: (0, globals_1._)("Identifiant"),
                        width: "400", attributes: { maxlength: 40 },
                        editor: "text", disabled: true, hidden: true
                    }, {
                        view: "text", name: "dateDemande", label: (0, globals_1._)("Demande le"),
                        width: "300", attributes: { maxlength: 40 },
                        disabled: true
                    }, {
                        view: "text", name: "module", id: "moduleId", label: (0, globals_1._)("Module"),
                        width: "400", attributes: { maxlength: 40 },
                        editor: "text", disabled: true
                    }, {
                        view: "select", name: "nature", label: (0, globals_1._)("Nature"),
                        width: "400", attributes: { maxlength: 40 },
                        options: ["Question", "Anomalie (bogue)", "Suggestion d'amélioration", "Assistance ou aide", "Demande de service"]
                    }, {
                        view: "textarea", name: "demande", label: (0, globals_1._)("Veuillez préciser votre demande"), labelPosition: "top",
                        labelAlign: "center", id: "assistance:demande",
                        width: "400", height: 200,
                        editor: "text"
                    }, { cols: [
                            { view: "button", label: (0, globals_1._)("Fermer"), id: "demandeFermerButton",
                                click: () => this.fermer()
                            }, {
                                view: "button", label: (0, globals_1._)("Envoyer"), id: "demandeEnvoyerButton",
                                click: () => this.envoyer()
                            }
                        ]
                    }]
            }
        };
    }
    constructor(app, config) {
        super(app, config);
    }
    init() {
        this.currentForm = $$("assistance.data");
        let me = this;
        me.assistanceData = me.currentForm.getValues();
        // @ts-ignore
        let promise = webix.ajax().get(globals_1.phpPath + "utilisateurs.php?option=mydata");
        promise.then(function (result) {
            if (result.json().unid < 0) {
                webix.alert(result.json().message);
                return;
            }
            me.assistanceData['nom'] = result.json().nom;
            me.assistanceData['prenom'] = result.json().prenom;
            me.assistanceData['idUtilisateur'] = result.json().idUtilisateur;
            me.currentForm.setValues(me.assistanceData);
        });
    }
    showWindow(optionMenu) {
        // @ts-ignore
        this.getRoot().show();
        this.assistanceData = this.currentForm.getValues();
        this.assistanceData['module'] = optionMenu;
        let options = {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric', second: 'numeric'
        };
        // @ts-ignore
        this.assistanceData.dateDemande = new Intl.DateTimeFormat('fr-FR', options).format(new Date());
        this.currentForm.setValues(this.assistanceData);
    }
    hideAssistance() {
        // @ts-ignore
        this.getRoot().hide();
    }
    fermer() {
        // @ts-ignore
        this.getRoot().hide();
    }
    envoyer() {
        let me = this;
        let values = this.currentForm.getValues();
        let vv = JSON.stringify(values);
        let xx = { "cle": "assistance.data", "texte": vv };
        // @ts-ignore
        let promise = webix.ajax().post(globals_1.phpPath + "utilisateurs.php?option=assistance", xx);
        promise.then(function (result) {
            if (result.json().success == false) {
                webix.alert(result.json().message);
                return;
            }
            else {
                webix.message(result.json().message);
                return;
            }
        });
        // @ts-ignore
        this.$$("assistance:demande").setValue("");
        this.hideAssistance();
    }
}
exports.default = Assistance;
